export default {
	string: '',
	header: null,
	users:  []
};
